module.exports = __webpack_public_path__ + "assets/img/5efe8dc64cdece00ab89972b76fff5bb.png";